import axios from '../axios'

// クイズ詳細（生徒には正解は含まれない）
const getQuizApi = async (quizId) => {
  return await axios.get(`api/lms/quizzes/${quizId}`)
}

export default getQuizApi
